// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"234":"1afffbea","329":"82253862","714":"5f04e892"}[chunkId] + ".chunk.css";
};